import { render, staticRenderFns } from "./u-loadmore.vue?vue&type=template&id=8a453272&scoped=true&"
import script from "./u-loadmore.vue?vue&type=script&lang=js&"
export * from "./u-loadmore.vue?vue&type=script&lang=js&"
import style0 from "./u-loadmore.vue?vue&type=style&index=0&id=8a453272&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a453272",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-loadmore/u-loadmore.vue"
export default component.exports